module.exports = __webpack_public_path__ + "img/brushes_jp.ec13503.jpg";